import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Text from "../../atoms/Text/Text";
import SpinnerLoader from "../../atoms/SpinnerLoader/SpinnerLoader";

import { formatDate } from "../../../helpers/formatDate";
import { formatPrice } from "../../../helpers/currencyHelper";
import { getSubscriptionTitle } from "../../../helpers/getSubscriptionTitle";
import { PaymentHistory } from "../../../types/rtk/paymentsHistory/paymentsHistory";
import { useDownloadInvoice } from "../../../hooks/useDownloadInvoice";

interface Props {
  data: PaymentHistory;
}

const PaymentHistoryCard = ({ data }: Props) => {
  const { t } = useTranslation();
  const { downloadInvoice, isFetching } = useDownloadInvoice();

  const handleDownloadInvoice = () => downloadInvoice(data.id);

  // Build subscription titles
  const subscriptionTitles = data.subscriptions.map((subscription) => 
    getSubscriptionTitle(subscription.period)
  );

  // Build option titles
  const optionTitles = data.options.map((option) => {
    if (option.code === "premium_pack") {
      return t("subscription:MANAGE_PAGE.ACCOUNT_OPTIONS.PREMIUM_PACK.TITLE");
    } else if (option.code === "warranty") {
      return t("subscription:MANAGE_PAGE.ACCOUNT_OPTIONS.WARRANTY.TITLE");
    }
    return "";
  });

  // Combine all titles with "+"
  const allTitles = [...subscriptionTitles, ...optionTitles]
    .filter(title => title !== "") // Filter out empty titles
    .join(" + ");



  return (
    <>
      <Box className="PaymentHistoryCard" onClick={handleDownloadInvoice}>
        <Box className="PaymentHistoryCardDetails--date">
          <Text children={formatDate(data.date)} />
        </Box>
        <Box className="PaymentHistoryCardDetails--title">
          <Text children={allTitles} />
        </Box>
        <Box className="PaymentHistoryCardDetails--price">
          <Text children={formatPrice(data.amount / 100, data.currency)} />
        </Box>
        <Box className="PaymentHistoryCardIcon">
          {isFetching ? (
            <SpinnerLoader size={24} />
          ) : (
            <ArrowForwardIosIcon className="Logos" />
          )}
        </Box>
      </Box>
    </>
  );
};

export default PaymentHistoryCard;